import { z } from 'zod';
import { emailSchema } from './common.js';
/**
 * Local credential login. Available when AUTH_PROVIDER is `local` or `both`;
 * in production this is the break-glass path while Entra ID is the norm.
 */
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1).max(200),
});
export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1).max(200),
    newPassword: z
        .string()
        .min(12, 'Use al menos 12 caracteres')
        .max(200)
        .refine((v) => /[a-z]/.test(v) && /[A-Z]/.test(v) && /[0-9]/.test(v), {
        message: 'Incluya minúsculas, mayúsculas y un número',
    }),
});
/** Query string returned by Entra ID on the authorization code redirect. */
export const entraCallbackSchema = z.object({
    code: z.string().min(1).max(4000).optional(),
    state: z.string().min(1).max(500).optional(),
    error: z.string().max(200).optional(),
    error_description: z.string().max(2000).optional(),
});
//# sourceMappingURL=auth.js.map